var _defs, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEIDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aDocument{fill:none;}.bDocument{fill:#b30200;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "aDocument",
    width: 32,
    height: 32,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bDocument",
    d: "M6,2A2.013,2.013,0,0,0,4,4V20a2.013,2.013,0,0,0,2,2H18a2.013,2.013,0,0,0,2-2V8L14,2ZM6,4h7V9h5V20H6Zm2,8v2h8V12Zm0,4v2h8V16Z",
    transform: "translate(4 4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEIDocument);
export default __webpack_public_path__ + "static/media/e_i_document.303df6e8ec9dca772b5b8db929b874fb.svg";
export { ForwardRef as ReactComponent };